import CommonCodeView from "./common-code.view";

/**
 * Common Code (Global & Country) View
 * 
 * Main code master page for system admins (MCS Developers) to easily add code into the database
 * 
 * @author CV Leong
 */
export default function CommonCodeSystemAdminView() {

  return {
    view: () => m(CommonCodeView, { systemAdminView: true })
  }
};
